export default "__VITE_ASSET__DBXVqBoq__"